import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';

import { map, catchError, switchMap, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';

import * as fromCustomViews from './custom-views-ui.reducer';
import { CustomViewsUiActions } from './custom-views-ui.actions';
import { CustomViewsUiService } from '../custom-views-ui.service';

@Injectable()
export class CustomViewsUiEffects {
    createCustomView$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CustomViewsUiActions.createCustomView),
            switchMap(action =>
                this.service
                    .createCustomView(action.parent, action.request)
                    .pipe(
                        map(customView =>
                            CustomViewsUiActions.createCustomViewSuccess({
                                custom_view: customView,
                            })
                        )
                    )
            ),
            catchError(error => {
                return of(
                    CustomViewsUiActions.createCustomViewFailure({ error })
                );
            })
        )
    );

    updateCustomView$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CustomViewsUiActions.updateCustomView),
            exhaustMap(action =>
                this.service
                    .updateCustomView(action.parent, action.request)
                    .pipe(
                        map(customView =>
                            CustomViewsUiActions.updateCustomViewSuccess({
                                custom_view: customView,
                            })
                        )
                    )
            ),
            catchError(error => {
                return of(
                    CustomViewsUiActions.updateCustomViewFailure({ error })
                );
            })
        )
    );

    deleteCustomView$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CustomViewsUiActions.deleteCustomView),
            switchMap(action =>
                this.service
                    .deleteCustomView(action.parent, action.request)
                    .pipe(
                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                        map(_ => {
                            return CustomViewsUiActions.deleteCustomViewSuccess({
                                custom_view: action.request,
                            });
                        })
                    )
            ),
            catchError(error => {
                return of(
                    CustomViewsUiActions.deleteCustomViewFailure({ error })
                );
            })
        )
    );

    constructor(
        private actions$: Actions,
        private service: CustomViewsUiService,
        private store: Store<fromCustomViews.CustomViewsState>
    ) {}
}
